export const BuildingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2 16V9C2 6.17157 2 4.75736 2.87868 3.87868C3.75736 3 5.17157 3 8 3C10.8284 3 12.2426 3 13.1213 3.87868C14 4.75736 14 6.17157 14 9V16C14 18.8284 14 20.2426 13.1213 21.1213C12.2426 22 10.8284 22 8 22C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
      stroke="#33363F"
      strokeWidth="2"
    />
    <path
      d="M14 8H16C18.8284 8 20.2426 8 21.1213 8.87868C22 9.75736 22 11.1716 22 14V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H9"
      stroke="#33363F"
      strokeWidth="2"
    />
    <path
      d="M10 17V18"
      stroke="#33363F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18 17V18"
      stroke="#33363F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10 12V13"
      stroke="#33363F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M18 7V8" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
    <path d="M10 2V3" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
    <path d="M6 2V3" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M18 12V13"
      stroke="#33363F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M10 7V8" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
    <path d="M6 17V18" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
    <path d="M6 12V13" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
    <path d="M6 7V8" stroke="#33363F" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
